import MonetizationOn from '@material-ui/icons/MonetizationOn'
import TradeRevAutoProxyList from './TradeRevAutoProxyList'
import TradeRevAutoProxyEdit from './TradeRevAutoProxyEdit'
import TradeRevAutoProxyCreate from './TradeRevAutoProxyCreate'

export default {
  name:'tradeRev-auto-proxys',
  options :{ label: 'TradeRev Auto Proxys' },
  list: TradeRevAutoProxyList,
  edit: TradeRevAutoProxyEdit,
  create: TradeRevAutoProxyCreate,
  icon: MonetizationOn
}
